// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"741ec58c","239":"b996a3fb","455":"f83a1350","672":"2a564911"}[chunkId] + ".chunk.js";
};